<template>
    <div>
        <div style="padding-bottom: 3%;" class="adway_subheaders">Step 1 / 4: Let’s start with basic info</div>
        <div class="input-area">
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your first name?</div>
              <input class="input-filed" type="text" name="firstname" placeholder="eg. Jane" v-model="firstname">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your last name?</div>
              <input class="input-filed" type="text" name="surname" placeholder="eg. Doe" v-model="surname">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your email?</div>
              <input class="input-filed" type="email" name="email" placeholder="eg. myemail@myemail.com" v-model="email">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your phone number?</div>
              <input class="input-filed" type="tel" name="tel" placeholder="123-456-7890" v-model="telephoneNumber" maxlength="50">
          </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast'
export default {
  name: 'PersonalInfo',
  data: function () {
    return {
      firstname: this.driver.name,
      surname: this.driver.surname,
      email: this.driver.email,
      telephoneNumber: this.driver.phoneNumber,
    }
  },
  props: {
    driver: Object
  },
  methods: {
    emailCheck () {
      return !this.email;
    },
    emailValidation () {
      if (!this.email.includes('@') || this.email.includes('@.')) {
        return false
      } else {
        return true
      }
    },
    preload() {
      this.firstname = this.driver.name;
      this.surname = this.driver.surname;
      this.email = this.driver.email;
      this.telephoneNumber = this.driver.phoneNumber;
    },
    changeSomeDriverSettings () {
      const errors = [];
      if (this.emailCheck()) {
        errors.push(`Email field is empty`);
      } else if (!this.emailValidation()) {
        errors.push(`Email is not valid`);
      }
      if (!this.firstname) errors.push(`First name field is empty`);
      if (!this.surname) errors.push(`Surname name field is empty`);
      if (!errors.length) {
        this.driver.name = this.firstname;
        this.driver.surname = this.surname;
        this.driver.email = this.email;
        this.driver.phoneNumber = this.telephoneNumber;
        this.$emit('changeDriver', this.driver);
      } else {
        toast.errorMessage(errors.join("<br>"));
      }
    }
  }
}
</script>
